import MentionsLegales from "../mentions-legals/MentionLegalesPage.jsx";

export default function MentionsLegalesPage() {
  return (
    <div className="mentions-legales-page">
      <MentionsLegales
        siteUrl="https://nice-plomberie.com/"
        nomSociete="NICE PLOMBERIE"
        capital="8 000,00 €"
        villeRcs="Nice"
        adresse="14 RUE EMMA ET PHILIPPE TIRANTY"
        siren="954802062"
        responsablePublication="Lukacevic Anthony"
        hebergeurNom="OVH SAS"
        hebergeurCapital="10 000 000 €"
        hebergeurAdresse="2, Rue Kellermann – 59100 Roubaix France"
      />
    </div>
  );
}
